import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let Icon = class Icon extends LitElement {
    constructor() {
        super(...arguments);
        this.customStyles = '';
        this.active = false;
    }
    render() {
        return html `<div class="icon-container">
      <svg
        style=${this.customStyles}
        width="18"
        height="19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.38 18.344H2.565A2.476 2.476 0 0 1 .08 15.858v-5.78a2.49 2.49 0 0 1 2.486-2.485h1.933L7.58.645a.867.867 0 0 1 .765-.489 3.319 3.319 0 0 1 3.315 3.315v2.486h3.845c.128 0 .255 0 .383.021a2.49 2.49 0 0 1 2.082 2.826l-1.147 7.436a2.453 2.453 0 0 1-2.444 2.104zm-8.52-1.658h8.498c.467-.02.765-.297.829-.7l1.147-7.437a.818.818 0 0 0-.701-.935H10.81a.816.816 0 0 1-.829-.829V3.471c0-.744-.488-1.36-1.147-1.572L5.859 8.613v8.073zM2.565 9.25a.83.83 0 0 0-.829.829v5.779a.83.83 0 0 0 .829.828h1.657V9.25H2.566z"
          fill=${this.active ? '#121212' : '#B3B2B2'}
        />
      </svg>
    </div>`;
    }
};
Icon.styles = css `
    .icon-container {
      border: 2px solid #d5d5d5;
      padding: 4px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      transition: all 0.2s ease-in-out;
    }
    :host.active .icon-container svg path,
    .icon-container:hover svg path {
      fill: #121212;
    }
  `;
__decorate([
    property({ type: String })
], Icon.prototype, "customStyles", void 0);
__decorate([
    property({ type: Boolean })
], Icon.prototype, "active", void 0);
Icon = __decorate([
    customElement('like-icon')
], Icon);
export { Icon };
//# sourceMappingURL=icon.js.map